import React, { useEffect, useRef } from "react";
import { LANDING_HTML } from "./data/landingHtml";
import { LANDING_SCRIPT } from "./data/landingScript";
import { IMAGE_MAP, applyImageMap } from "./data/imageMap";
import { initPricing } from "./data/pricing";
import { INSIDE_HTML, initInside } from "./data/insideSection";
import { initAnchorScroll } from "./utils/anchorScroll";
const BRAND = "Reconecta con tu mascota";

// "perro" -> "mascota" en textos generales. Los títulos de tomos y bonos quedan igual que en los PDFs.
const MASCOTA_HTML: Array<[string, string]> = [["Quieres a tu perro.", "Quieres a tu mascota."], ["de entender cómo aprende tu perro a mantener lo aprendido", "de entender cómo aprende tu mascota a mantener lo aprendido"], ["¿Qué te pasa hoy con tu perro?", "¿Qué te pasa hoy con tu mascota?"], ["Vas de entender a tu perro a mantener lo aprendido.", "Vas de entender a tu mascota a mantener lo aprendido."], ["sin forzar el cuerpo de tu perro.", "sin forzar el cuerpo de tu mascota."], ["anotas lo que logran tú y tu perro.", "anotas lo que logran tú y tu mascota."], ["Nunca entrenaste a un perro y quieres pasos claros.", "Nunca entrenaste a una mascota y quieres pasos claros."], ["<li>Tu perro tiene agresividad grave", "<li>Tu mascota tiene agresividad grave"], ["cada perro aprende a su ritmo.</li>", "cada mascota aprende a su ritmo.</li>"], ["que ya tenga tu perro, sea cachorro o adulto.", "que ya tenga tu mascota, sea cachorro o adulto."], ["premiar lo que quieres que tu perro repita", "premiar lo que quieres que tu mascota repita"], ["No. Cada perro aprende a su ritmo", "No. Cada mascota aprende a su ritmo"], ["tú y tu perro lo recorren.", "tú y tu mascota lo recorren."], ["Si tu perro tiene dolor", "Si tu mascota tiene dolor"], ["Porque disfrutar a tu perro en casa", "Porque disfrutar a tu mascota en casa"], ["del ritmo de cada perro;", "del ritmo de cada mascota;"]];
const MASCOTA_SCRIPT: Array<[string, string]> = [["¡Semana completa! Tu perro lo nota.", "¡Semana completa! Tu mascota lo nota."], ["La base del método: cómo aprende tu perro,", "La base del método: cómo aprende tu mascota,"]];
function replaceAll(src: string, pairs: Array<[string, string]>): string {
  return pairs.reduce((s, [from, to]) => s.split(from).join(to), src);
}

// El script arma las URLs como prefijo + id; se convierte a URLs completas antes de reemplazar.
function resolveScript(src: string): string {
  let s = src.split("var U='https://lh3.googleusercontent.com/d/';").join("var U='';");
  for (const [from] of IMAGE_MAP) {
    const id = from.replace("https://lh3.googleusercontent.com/d/", "");
    s = s.split("'+U+'" + id).join("'+'" + from);
  }
  // El bloque de precio viejo (interruptor Argentina / Otros países) lo reemplaza data/pricing.ts
  s = s.replace(/var P=\{ar:[\s\S]*?catch\(e\)\{\}/, "");
  s = replaceAll(s, MASCOTA_SCRIPT);
  return applyImageMap(s);
}
function resolveHtml(src: string): string {
  // Interruptor viejo -> selector de país con detección automática
  let html = src.replace(/<div class="tog"[\s\S]*?<\/div>/, '<div class="geo" id="geo"></div>');
  // Tomo 1: etiquetas combinadas para que las dos filas queden parejas
  html = html.split("<ul><li>Premios</li><li>Marcador</li><li>Casa preparada</li><li>Sesiones cortas</li></ul>").join("<ul><li>Casa preparada</li><li>Marcador</li><li>Premios</li><li>Sesiones cortas</li></ul>");
  // Lista de compra: los bonos dicen "Gratis" (en verde)
  html = html.split('<span class="g">Bono</span>').join('<span class="g free">Gratis</span>');
  // Nueva sección "Mira cómo se ve por dentro" (entre los tomos y los bonos)
  html = html.replace("<!-- BONOS -->", INSIDE_HTML + "<!-- BONOS -->");
  // Hero nuevo: título (tagline) + texto grande sobre el mockup
  html = html.split("🐾 Entrenamiento en casa · Refuerzo positivo").join("🐾 " + BRAND);
  html = html.split('<h1>Un perro que te hace caso.<span class="l2">Sin gritos. Sin castigos.</span></h1>').join('<h1>La guía definitiva para que tu mascota te escuche.<span class="l2">Sin gritos ni castigos.</span></h1>');
  // Mockup del hero: se descarga primero
  html = html.split('width="1000" height="913"').join('width="1000" height="913" fetchpriority="high"');
  // Nombre de marca en logo, oferta, pie y textos alternativos
  html = html.split("Perro Obediente en Casa").join(BRAND);
  html = replaceAll(html, MASCOTA_HTML);
  return applyImageMap(html);
}
export function App() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    root.innerHTML = resolveHtml(LANDING_HTML);
    document.title = BRAND + " | La guía definitiva para que tu mascota te escuche";
    let cleanup: unknown;
    let cleanupPricing: () => void = () => undefined;
    let cleanupInside: () => void = () => undefined;
    let cleanupAnchors: () => void = () => undefined;
    try {
      // eslint-disable-next-line no-new-func
      cleanup = new Function("return " + resolveScript(LANDING_SCRIPT))();
    } catch (e) {
      console.error(e);
    }
    try {
      cleanupPricing = initPricing(root);
    } catch (e) {
      console.error(e);
    }
    try {
      cleanupInside = initInside(root);
    } catch (e) {
      console.error(e);
    }
    try {
      cleanupAnchors = initAnchorScroll(root);
    } catch (e) {
      console.error(e);
    }
    return () => {
      if (typeof cleanup === "function") (cleanup as () => void)();
      cleanupPricing();
      cleanupInside();
      cleanupAnchors();
      root.innerHTML = "";
    };
  }, []);
  return <div ref={ref} data-id="element-0" data-mp="2nw4djygm2tft" />;
}